module.exports = "data:image/webp;base64,UklGRjQAAABXRUJQVlA4ICgAAADwAgCdASpBAAIAPpFEnUqlo6KhpmgAsBIJaQAAMReLAAD++E0AAAAA"